import wordpress from './wordpress'

const integrations = {
    wordpress: Object.assign(wordpress, wordpress),
}

export default integrations